import { Translate } from "../../constant/Translate"

const { TEXT_T071, TEXT_T074 } = Translate

export const getTextConfirm = (isCheck: boolean) =>
  isCheck ? TEXT_T071 : TEXT_T074
